import { Page, StyleSheet, Text, View } from '@react-pdf/renderer';
import React, { Fragment } from 'react';
import { displayFormattedDate, formatCurrency, getAccountHolderName, isEmpty } from '../../../generalFunctions';
import { EMPTY_VALUE, FIRM_NAME } from '../../../constants';

const LedgerReport = (props) => {
    let pagewiseData = [];
    let pageData = [];
    let maxLineCount = 0;
    let closingDebitBalance = 0;
    let closingCreditBalance = 0;
    let totalClosingDebitBalance = 0;
    let totalClosingCreditBalance = 0;

    if (!isEmpty(props.data.ledgerData)) {
        props.data.ledgerData.forEach((element, index) => {
            if (parseInt(maxLineCount) > 30) { // max 30 lines per page
                if (pageData.length > 0) {
                    let previousClosingBalanceArray;
                    let pageObject;
                    if (pagewiseData.length > 0) {
                        previousClosingBalanceArray = pagewiseData[pagewiseData.length - 1].ledgerData;
                        let lastRecord = { ...previousClosingBalanceArray[previousClosingBalanceArray.length - 2] };
                        if (lastRecord.balance.includes("Cr")) {
                            lastRecord.particulars = "by Balance Carry Forward";
                            lastRecord.credit = EMPTY_VALUE;
                            lastRecord.debit = EMPTY_VALUE;
                        } else {
                            lastRecord.particulars = "to Balance Carry Forward";
                            lastRecord.credit = EMPTY_VALUE;
                            lastRecord.debit = EMPTY_VALUE;
                        }
                        pageData.unshift(lastRecord);
                        pageData.push({
                            credit: formatCurrency(closingCreditBalance.toFixed(2)),
                            debit: formatCurrency(closingDebitBalance.toFixed(2))
                        });
                        pageObject = {
                            openingBalance: pagewiseData.length === 0 ? props.data.openingBalance : pageData[pageData.length - 1].balance,
                            closingDebitBalance: closingDebitBalance,
                            closingCreditBalance: closingCreditBalance,
                            ledgerData: pageData,
                        }
                    } else {
                        pageData.push({
                            credit: formatCurrency(closingCreditBalance.toFixed(2)),
                            debit: formatCurrency(closingDebitBalance.toFixed(2))
                        });
                        pageObject = {
                            openingBalance: pagewiseData.length === 0 ? props.data.openingBalance : pageData[pageData.length - 1].balance,
                            closingDebitBalance: closingDebitBalance,
                            closingCreditBalance: closingCreditBalance,
                            ledgerData: pageData,
                        }
                    }

                    pagewiseData.push(pageObject);
                }

                //reset for next counter
                pageData = [];
                maxLineCount = 0;
                closingDebitBalance = 0;
                closingCreditBalance = 0;
            }

            if (element.debit!==undefined) {
                closingDebitBalance = closingDebitBalance + element.debit;
                element.debit = formatCurrency(element.debit);
            }
            else {
                closingCreditBalance = closingCreditBalance + element.credit;
                element.credit = formatCurrency(element.credit);
            }
            element.date = displayFormattedDate(element.date);
            element.particulars = !isEmpty(element.chequeNumber) ? element.particulars + " CHQ No. " + element.chequeNumber : element.particulars;
            element.balance = formatCurrency(element.balance.split(" ")[0]) + " " + element.balance.split(" ")[1];
            element.lineCount = (element.particulars.length / 40) + 1;
            maxLineCount = maxLineCount + parseInt(element.lineCount);
            pageData.push(element);
        });
        //page wise ledger data
        if (parseInt(maxLineCount) <= 34 && pageData.length > 0) {
            let previousClosingBalanceArray;
            let pageObject;
            if (pagewiseData.length > 0) {
                previousClosingBalanceArray = pagewiseData[pagewiseData.length - 1].ledgerData;
                let lastRecord = { ...previousClosingBalanceArray[previousClosingBalanceArray.length - 2] };
                if (lastRecord.balance.includes("Cr")) {
                    lastRecord.particulars = "by Balance Carry Forward";
                    lastRecord.credit = EMPTY_VALUE;
                    lastRecord.debit = EMPTY_VALUE;
                } else {
                    lastRecord.particulars = "to Balance Carry Forward";
                    lastRecord.credit = EMPTY_VALUE;
                    lastRecord.debit = EMPTY_VALUE;
                }
                pageData.unshift(lastRecord);
                pageData.push({
                    credit: formatCurrency(closingCreditBalance.toFixed(2)),
                    debit: formatCurrency(closingDebitBalance.toFixed(2))
                });
                pageObject = {
                    openingBalance: lastRecord.balance,
                    closingDebitBalance: closingDebitBalance,
                    closingCreditBalance: closingCreditBalance,
                    ledgerData: pageData,
                }
            } else {
                pageObject = {
                    openingBalance: pagewiseData.length === 0 ? props.data.openingBalance : previousClosingBalanceArray[previousClosingBalanceArray.length - 1].balance,
                    closingDebitBalance: closingDebitBalance,
                    closingCreditBalance: closingCreditBalance,
                    ledgerData: pageData,
                }
            }

            pagewiseData.push(pageObject);
        }
    } else {
        let pageObject = {
            openingBalance: props.data.openingBalance,
            closingDebitBalance: closingDebitBalance,
            closingCreditBalance: closingCreditBalance,
            ledgerData: [],
        }

        pagewiseData.push(pageObject);
    }

    if (pagewiseData.length > 0) {
        pagewiseData.forEach((page, index) => {
            totalClosingCreditBalance = totalClosingCreditBalance + page.closingCreditBalance;
            totalClosingDebitBalance = totalClosingDebitBalance + page.closingDebitBalance;

            if (index === pagewiseData.length - 1) {
                pagewiseData[index].ledgerData.push({
                    particulars: "Total",
                    debit: formatCurrency(totalClosingDebitBalance),
                    credit: formatCurrency(totalClosingCreditBalance)
                })
            }
        });
    }

    const tableData = {
        columnName: ["Date", "Particulars", "Debit", "Credit", "Balance"],
        column: ["date", "particulars", "debit", "credit", "balance"],
        width: [12, 38, 16, 16, 18],
        alignHeader: ["center", "center", "right", "right", "center"],
        align: ["center", "left", "right", "right", "center"],
        data: !isEmpty(props.data.ledgerData) ? props.data.ledgerData : []
    }

    return (
        <>
            {pagewiseData.map((pageData, index) => {
                return <Page style={{ marginRight: 5 }} id={props.data.id} size="A4" key={index}>
                    <View style={{ flexDirection: "row", paddingBottom: 5, paddingTop: 15, alignSelf: "center" }}>
                        <Text style={{
                            fontSize: 16,
                            flexDirection: "column",
                            flexGrow: 1
                        }}>{FIRM_NAME}</Text>
                    </View>
                    <View style={{ flexDirection: "row", padding: 10, paddingBottom: 3 }}>
                        <Text style={{
                            fontSize: 10,
                            flexDirection: "column",
                            flexGrow: 0.05
                        }}>A/C NAME:</Text>
                        <Text style={{
                            fontSize: 10,
                            flexDirection: "column",
                            marginRight: 20,
                            flexGrow: 1
                        }}>{getAccountHolderName(props.data.accountId)}</Text>
                    </View>
                    <View style={{ flexDirection: "row", padding: 10, paddingBottom: 3 }}>
                        <Text style={{
                            fontSize: 10,
                            flexDirection: "column",
                            flexGrow: 0.05
                        }}>A/C Ledger for the Period:</Text>
                        <Text style={{
                            fontSize: 10,
                            flexDirection: "column",
                            marginRight: 20,
                            flexGrow: 1
                        }}>{displayFormattedDate(props.data.startDate) + " to " + displayFormattedDate(props.data.endDate)}</Text>
                    </View>
                    {index === 0 && <View style={{ flexDirection: "row", padding: 10, paddingBottom: 12 }}>
                        <Text style={{
                            fontSize: 10,
                            flexDirection: "column",
                            flexGrow: 0.05
                        }}>{index > 0 ? "Carry Forward Balance:" : "Opening Balance:"}</Text>
                        <Text style={{
                            fontSize: 10,
                            flexDirection: "column",
                            marginRight: 20,
                            flexGrow: 1,
                        }}>{pageData.openingBalance.includes(",") ? pageData.openingBalance : formatCurrency(pageData.openingBalance.split(" ")[0]) + " " + pageData.openingBalance.split(" ")[1]}</Text>
                    </View>}

                    <Fragment>
                        <View style={{ flexDirection: 'row', borderBottom: 1, borderTop: 1, paddingTop: 10, paddingBottom: 10, fontWeight: "bold" }}>
                            {tableData["columnName"].map((c, index) => <Text key={index} style={{
                                width: `${tableData["width"][index]}%`, fontSize: 8, textAlign: tableData["alignHeader"][index]
                            }}>{c.toUpperCase()}</Text>)}
                        </View>
                        {pageData.ledgerData.map((rowData, rowDataIndex) => <>
                            <View style={{ flexDirection: 'row', padding: 5, alignSelf: "center" }}>
                                {tableData["column"].map((c, index) => {
                                    if (!isEmpty(rowData.balance))
                                        return <Text key={index} style={{ width: `${tableData["width"][index]}%`, fontSize: 9, textAlign: tableData["align"][index] }}>{rowData[c]}</Text>
                                    else
                                        return <Text key={index} style={{ width: `${tableData["width"][index]}%`, fontSize: 9, textAlign: tableData["align"][index], borderTop: 1, borderBottom: 1, paddingTop: 5, paddingBottom: 5 }}>{rowData[c]}</Text>
                                }
                                )}
                            </View>
                        </>)}

                    </Fragment>
                </Page>
            })}
        </>
    );
}

export default LedgerReport;